import cn from 'classnames';
import { KibButtonNew, type KibButtonNewProps } from '@chewy/kib-controls-react';
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import styles from './ChatButton.module.scss';

interface ChatButtonProps extends KibButtonNewProps {
  buttonText: string;
}

export default function ChatButton(props: ChatButtonProps) {
  const { buttonText, className, ...rest } = props;

  return (
    <KibButtonNew
        type="button"
        {...rest}
        className={cn(styles.chatButton, className)}
    >
        {buttonText}
    </KibButtonNew>
  );
}
